export const getFullName = (
  firstName?: string | null,
  lastName?: string | null,
  fallback = 'Usuario'
): string => {
  const fullName = [firstName, lastName]
    .filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

  return fullName || fallback;
};

export const getNameInitials = (
  firstNameOrFullName?: string | null,
  lastName?: string | null,
  fallback = 'US'
): string => {
  const fullName = getFullName(firstNameOrFullName, lastName, '');

  if (!fullName) {
    return fallback;
  }

  const words = fullName
    .split(' ')
    .map((word) => word.trim())
    .filter(Boolean);

  if (words.length === 1) {
    const singleWord = words[0].replace(/[^a-zA-Z0-9À-ÿ]/g, '');
    return (singleWord.slice(0, 2) || fallback).toUpperCase();
  }

  return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
};
